import { render, staticRenderFns } from "./planning-allocation-form.vue?vue&type=template&id=8f590cc8&"
import script from "./planning-allocation-form.vue?vue&type=script&lang=js&"
export * from "./planning-allocation-form.vue?vue&type=script&lang=js&"
import style0 from "./planning-allocation-form.vue?vue&type=style&index=0&id=8f590cc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports